import { render } from "./BibliotecaIcon.vue?vue&type=template&id=b8a2fa08&scoped=true"
import script from "./BibliotecaIcon.vue?vue&type=script&lang=js"
export * from "./BibliotecaIcon.vue?vue&type=script&lang=js"

import "./BibliotecaIcon.vue?vue&type=style&index=0&id=b8a2fa08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a2fa08"]])

export default __exports__